module.exports = __webpack_public_path__ + "49620a3f9af1d336719cfa1113db29df.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-group-type/sp-group-type.html
// module id = 1011
// module chunks = 0